const config = {
    development: {
        apiUrl: 'http://localhost:3000/'
    },
    production: {
        apiUrl: 'https://procureria.onrender.com/'
    }
};

const environment = import.meta.env.MODE || 'production';
export const apiUrl = config[environment].apiUrl;
